// The email the upgrade cart + checkout must carry, so the checkout page can find
// the cart by its `for_email` filter (cartId + email). It is resolved from, in order:
//   1. the form/state email (set when the customer typed it, or after the token load), then
//   2. the loaded appointment's cart email (the booking's own email), then
//   3. the appointment's order email.
//
// Why the fallback matters: on the staff-sent upgrade link (auto-upgrade), React 17
// does NOT batch the state updates in the token-load promise, so the auto-upgrade
// effect can fire goUpgrade() BEFORE setEmail() lands -- leaving the `email` state
// blank. A blank-email cart is invisible to the checkout's `for_email` lookup, so the
// customer could never complete the upgrade. Sourcing from the already-loaded
// appointment makes this independent of that render timing.
export function resolveUpgradeEmail(emailState, appointment) {
  const fromState = (emailState || '').trim()
  if (fromState) return fromState

  const fromCart = (appointment?.cart?.email || '').trim()
  if (fromCart) return fromCart

  return (appointment?.order?.email || '').trim()
}
